import { render } from "./SidebarBackground.vue?vue&type=template&id=19b88ee2&scoped=true"
import script from "./SidebarBackground.vue?vue&type=script&lang=js"
export * from "./SidebarBackground.vue?vue&type=script&lang=js"

import "./SidebarBackground.vue?vue&type=style&index=0&id=19b88ee2&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b88ee2"]])

export default __exports__